/* eslint-disable react/no-unescaped-entities */
'use client';

import React from 'react';
import { Card, Heading } from '@ui';
import { withOptionalId } from '@lib/withOptionalId';
import { Section, Container } from '@layout';

interface CardSkeletonsProps {
  sectionID?: string;
  classes?: string;
  containerId?: string;
  containerClasses?: string;
  isSpanish?: boolean;
}

const CardSkeletons = ({
  isSpanish = false,
  sectionID = '',
  classes = '',
  containerId,
  containerClasses,
}: CardSkeletonsProps) => {
  const tc = (en: string, es: string) => (isSpanish ? es : en);

  return (
    <Section {...withOptionalId(sectionID)} className={classes}>
      <Container containerId={containerId} containerClasses={containerClasses}>
        <Heading as='h3'>{tc('Skeletons & Empty States', 'Skeletons y estados vacíos')}</Heading>
        <p className='sub full'>
          {tc(
            'Shimmer placeholders during load and friendly empty screens with CTAs.',
            'Skeletons con destellos mientras se carga y pantallas vacías amables con CTA.'
          )}
        </p>

        <Card className='card'>
          <div className='card-header'>
            <Heading as='h4'>{tc('Card skeletons', 'Skeletons de tarjetas')}</Heading>
          </div>

          <div className='grid-3 mt-16'>
            <Card className='skeleton'>
              <div
                className='skeleton-rect'
                style={{ '--h': '140px' } as React.CSSProperties}
              ></div>
              <div
                className='skeleton-line mt-12'
                style={{ '--w': '70%' } as React.CSSProperties}
              ></div>
              <div
                className='skeleton-line mt-8'
                style={{ '--w': '40%' } as React.CSSProperties}
              ></div>
            </Card>
            <Card className='skeleton'>
              <div
                className='skeleton-rect'
                style={{ '--h': '140px' } as React.CSSProperties}
              ></div>
              <div
                className='skeleton-line mt-12'
                style={{ '--w': '60%' } as React.CSSProperties}
              ></div>
              <div
                className='skeleton-line mt-8'
                style={{ '--w': '35%' } as React.CSSProperties}
              ></div>
            </Card>
            <Card className='skeleton'>
              <div
                className='skeleton-rect'
                style={{ '--h': '140px' } as React.CSSProperties}
              ></div>
              <div
                className='skeleton-line mt-12'
                style={{ '--w': '65%' } as React.CSSProperties}
              ></div>
              <div
                className='skeleton-line mt-8'
                style={{ '--w': '50%' } as React.CSSProperties}
              ></div>
            </Card>
          </div>
        </Card>

        <Card className='card'>
          <div className='card-header'>
            <Heading as='h4'>{tc('Empty state', 'Estado vacío')}</Heading>
          </div>
          <div className='empty-state'>
            <div className='empty-illustration'></div>
            <div className='empty-copy'>
              <Heading as='h5' style={{ margin: 0 }}>
                {tc('No documents yet', 'Aún no hay documentos')}
              </Heading>
              <p className='sub full'>
                {tc(
                  'Create your first protocol or import an SOP template to get started.',
                  'Crea tu primer protocolo o importa una plantilla SOP para comenzar.'
                )}
              </p>
              <div className='row btn-row mt-12'>
                <button className='btn btn-primary'>
                  {tc('Create document', 'Crear documento')}
                </button>
                <button className='btn btn-ghost'>
                  {tc('Import template', 'Importar plantilla')}
                </button>
              </div>
            </div>
          </div>
        </Card>
      </Container>
    </Section>
  );
};

export default CardSkeletons;
